import React from "react";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { Divider } from "@mui/material";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}
const ReferAndEarn = () => {
  const navigate = useNavigate();

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <div className="flex gap-5 py-5 px-3">
        <ArrowBackIcon onClick={() => navigate("/profile")} />
        <p> My Refer & Earn</p>
      </div>
      <div className="bg-blue-800">
        <div className="py-5 px-3 flex gap-5 text-white  text-xl">
          My Refer & Earn
        </div>
        <div className="pt-10 text-center">
          <p className="text-white text-lg"> Total Deposited</p>
          <p className="text-white text-lg font-bold">₹ 0</p>
        </div>
      </div>
      <div className="py-5 px-3">
        <div className="border-t-8 border-green-500 rounded-2xl"></div>
        <div className="bg-gray-100 rounded-xl">
          <p className="px-3 py-4">
            <p className="py-2">Welcome</p>
            <p className="font-bold py-2">
              Lets get started with adding your bank account.
            </p>
            <p className="py-2">
              This account will be used for all kinds of payments, i.e.
              commissions and bonus.
            </p>
          </p>
        </div>
      </div>
      <Divider className="!py-3" />
      <Box
        sx={{
          flexGrow: 1,
          bgcolor: "background.paper",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Tabs
          className="!capitalize !px-7"
          orientation="horizontal"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          sx={{ borderRight: 1, borderColor: "divider" }}
        >
          <Tab
            className="!capitalize "
            label={<>Invite Friends</>}
            {...a11yProps(0)}
          />
          <Tab
            className="!capitalize !px-5 "
            label={<>Signed up</>}
            {...a11yProps(1)}
          />
        </Tabs>
        <Divider />
        <div className="">
          <TabPanel value={value} index={0}></TabPanel>
          <TabPanel value={value} index={1}>
            <div className="flex justify-center py-5 mb-10">
              <div className="border-2 flex-col flex  p-3 ">
                <p className="text-center">0</p>
                <p>Signed </p>
              </div>
              <div className="border-t-2 border-b-2 flex-col flex  p-3">
                <p className="text-center">0</p>
                <p>Ordered</p>
              </div>
              <div className="border-2 flex-col flex  p-3 rounded-t">
                <p className="text-center">0</p>
                <p>Successful</p>
              </div>
            </div>
          </TabPanel>
        </div>
      </Box>
    </>
  );
};
export default ReferAndEarn;
